export const ASSETS_PATH = "./assets/icons/";
